/**
 * Extracts a specified number of items following a key from a delimited string
 * @param data - String containing delimited data using '||' as separator
 * @param key - Key to search for in the data
 * @param followOnItemCnt - Number of items to extract following the key (default: 1)
 * @param concatStr - String to use when concatenating multiple extracted values (default: ', ')
 * @param extractItemQty - Maximum number of times to perform extraction (default: 1)
 * @returns Concatenated string of extracted values
 */
const extractFollowingXByKey = (data: string, key: string, followOnItemCnt = 1, concatStr = ', ', extractItemQty = 1) => {
  let extractedValue = '';
  const splitData = data.split('||');
  const itemCnt = splitData.length;
  let extractItemCnt = 1;
  for (let x = 0; x < itemCnt; x++) {
    if (splitData[x] === key && extractItemCnt <= extractItemQty) {
      // if (splitData[x] === key) {
      let extractCnt = 1;
      extractItemCnt++;
      while (extractCnt <= followOnItemCnt) {
        if (extractCnt > 1 && concatStr.length > 0) {
          extractedValue += concatStr;
        }
        extractedValue += splitData[x + extractCnt];

        extractCnt++;
      }
    }
  }
  return extractedValue;
};

/**
 * Extracts items where the key contains specified string from a delimited string
 * @param data - String containing delimited data using '||' as separator
 * @param keyContains - String to search for within keys
 * @param followOnItemCnt - Number of items to extract (default: 1)
 * @param concatStr - String to use when concatenating multiple extracted values (default: ', ')
 * @param extractItemQty - Maximum number of times to perform extraction (default: 1)
 * @returns Concatenated string of extracted values
 */
const extractWhereKeyContains = (data: string, keyContains: string, followOnItemCnt = 1, concatStr = ', ', extractItemQty = 1) => {
  let extractedValue = '';
  const splitData = data.split('||');
  const itemCnt = splitData.length;
  let extractItemCnt = 1;
  for (let x = 0; x < itemCnt; x++) {
    if (String(splitData[x]).indexOf(keyContains) > -1 && extractItemCnt <= extractItemQty) {
      // if (splitData[x] === key) {
      // let extractCnt = 1;
      // extractItemCnt++;
      // while (extractCnt <= followOnItemCnt) {
      if (extractItemCnt > 1 && concatStr.length > 0) {
        extractedValue += concatStr;
      }
      extractedValue += splitData[x];
      //
      //   extractCnt++;
      // }
    }
  }
  return extractedValue;
};

/**
 * Extracts values between two specified keys from a delimited string
 * @param data - String containing delimited data using '||' as separator
 * @param key - Starting key to begin extraction
 * @param untilKey - Ending key to stop extraction
 * @param concatStr - String to use when concatenating multiple extracted values (default: ', ')
 * @returns Concatenated string of extracted values between the start and end keys
 */
const extractFollowingUntilByKeys = (data: string, key: string, untilKey: string, concatStr = ', ') => {
  let extractedValue = '';
  const splitData = data.split('||');
  const itemCnt = splitData.length;
  let extractData = false;
  for (let x = 0; x < itemCnt; x++) {
    if (extractData) {
      if (splitData[x] === untilKey) {
        break;
      }
      if (extractedValue.length > 0 && concatStr.length > 0) {
        extractedValue += concatStr;
      }
      extractedValue += splitData[x];
    }
    extractData = extractData || splitData[x] === key;
  }
  return extractedValue;
};

export { extractFollowingUntilByKeys, extractFollowingXByKey, extractWhereKeyContains };
